"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationFactorType = void 0;
var AuthenticationFactorType;
(function (AuthenticationFactorType) {
    AuthenticationFactorType["FIDO_CREDENTIAL"] = "FIDO_CREDENTIAL";
    AuthenticationFactorType["FIDO_CREDENTIAL_PLATFORM"] = "FIDO_CREDENTIAL_PLATFORM";
    AuthenticationFactorType["FIDO_CREDENTIAL_CROSS_PLATFORM"] = "FIDO_CREDENTIAL_CROSS_PLATFORM";
    AuthenticationFactorType["DEVICE_USER_CREDENTIAL"] = "DEVICE_USER_CREDENTIAL";
    AuthenticationFactorType["ID_DOCUMENT"] = "ID_DOCUMENT";
    AuthenticationFactorType["ID_DRIVERS_LICENCE"] = "ID_DRIVERS_LICENCE";
    AuthenticationFactorType["BIOMETRICS_FACE_SCAN_PROOFING"] = "BIOMETRICS_FACE_SCAN_PROOFING";
    AuthenticationFactorType["LIVENESS"] = "LIVENESS";
    AuthenticationFactorType["OTP_MOBILE_MESSAGE"] = "OTP_MOBILE_MESSAGE";
})(AuthenticationFactorType = exports.AuthenticationFactorType || (exports.AuthenticationFactorType = {}));
//# sourceMappingURL=AuthenticationFactorType.js.map